// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"25":"e811f68a","150":"bfe90a21","628":"7d8926b2"}[chunkId] + ".css";
};